import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "q-ml-sm" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { ref } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogToDoDelete',
  props: {
  amount: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const checkboxVal = ref(false)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-dialog__title text-h5" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogToDo.title_discard_todo")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('sfxDialogToDo.content_discard_todo', { amount: props.amount })
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "row items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_checkbox, {
                size: "40px",
                class: "sfx-checkbox",
                "checked-icon": _unref(Icons).ACCEPT,
                modelValue: checkboxVal.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkboxVal).value = $event))
              }, null, 8, ["checked-icon", "modelValue"]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("sfxDialogToDo.content_discard_todo_all")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: _ctx.$t('sfxButtons.btn_cancel'),
                class: "col-grow"
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onDialogOK)(checkboxVal.value))),
                label: _ctx.$t('sfxButtons.btn_confirm'),
                class: "col-grow"
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})